import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { apiSignIn, apiSignUp } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import { logOutWorkSpace } from 'store/workSpace/workSpaceSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'

function useAuth() {

    const dispatch = useDispatch()

    const navigate = useNavigate()

	const query = useQuery()

    const { accessToken, refreshToken, signedIn } = useSelector((state) => state.auth.session)
	const workSpace = useSelector(state => state.workSpace)

    const signIn = async (values) => {
        try {
			const resp = await apiSignIn(values)
			if (resp.data) {
				const { session, user } = resp.data.data
				dispatch(onSignInSuccess(session))
				if(user) {
					dispatch(setUser(user || {
						first_name: 'Anonymous',
						last_name: 'Anonymous',
						authority: ['USER'],
						email: ''
					}))
				}
				const redirectUrl = query.get(REDIRECT_URL_KEY)
				navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath)
                return {
                    status: 'success',
                    message: ''
                }
			}
		} catch (errors) {
			return {
                status: 'failed',
                message: errors?.data?.message || errors.toString()
            }
		}
    }

	const signUp = async (values) => {
        try {
			const resp = await apiSignUp(values)
			if (resp.data) {
                return {
                    status: 'success',
                    message: ''
                }
			}
		} catch (errors) {
			console.log(errors)
			return {
                status: 'failed',
                message: errors?.data?.message || errors.toString()
            }
		}
    }

    const handleSignOut = ()  => {
		dispatch(onSignOutSuccess())
		dispatch(setUser(initialState))
		dispatch(logOutWorkSpace())
		localStorage.workSpacesSelected = JSON.stringify({})
		navigate(appConfig.unAuthenticatedEntryPath)
	}

    const signOut = async () => {
		handleSignOut()
	}

    return {
        authenticated: accessToken && signedIn,
        workSt: workSpace.workSpaceStatus,
		accessToken,
		refreshToken,
        signIn,
		signUp,
        signOut
    }
}

export default useAuth
